import api from '@/api/index.js'

const account_municipalities = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_ACCOUNT_MUNICIPALITIES_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_ACCOUNT_MUNICIPALITIES: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_ACCOUNT_MUNICIPALITIES_ERROR: (state, error) => {
      state.error = error;
      state.loading = false;
    }
  },

  actions: {
    LoadAccountMunicipalities({commit}, accountID) {
      commit('SET_ACCOUNT_MUNICIPALITIES_ERROR', null)
      commit('SET_ACCOUNT_MUNICIPALITIES_LOADING', true)
      return api.get(`accounts/${accountID}/municipalities?limit=150&offset=0`)
        .then((response) => {
          commit('SET_ACCOUNT_MUNICIPALITIES', response)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_MUNICIPALITIES_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    }
  },
}

export default account_municipalities
